import React, { useState } from 'react';
import './MockInterviewsTab.css';
import CompaniesSubTab from './CompaniesSubTab';
import MockInterviewsSubTab from './MockInterviewsSubTab';
import MockInterviewQuestionsSubTab from './MockInterviewQuestionsSubTab';
import MockInterviewStatisticsSubTab from './MockInterviewStatisticsSubTab';
import MockInterviewGenerationSubTab from './MockInterviewGenerationSubTab';
import UserMockInterviewsSubTab from './UserMockInterviewsSubTab';
import UserMockInterviewQuestionsSubTab from './UserMockInterviewQuestionsSubTab';
import UserMockInterviewCompletionsSubTab from './UserMockInterviewCompletionsSubTab';

function MockInterviewsTab() {
  const [activeSubTab, setActiveSubTab] = useState('companies');

  return (
    <div className="mock-interviews-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'companies' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('companies')}
        >
          Компании
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'interviews' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('interviews')}
        >
          Mock-собеседования
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'questions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('questions')}
        >
          Вопросы
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'generation' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('generation')}
        >
          Генерация из текста
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'statistics' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('statistics')}
        >
          Статистика прохождений
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'user-interviews' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('user-interviews')}
        >
          Пользовательские собеседования
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'user-questions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('user-questions')}
        >
          Вопросы пользовательских собеседований
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'user-completions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('user-completions')}
        >
          Статистика прохождений
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'companies' && <CompaniesSubTab />}
        {activeSubTab === 'interviews' && <MockInterviewsSubTab />}
        {activeSubTab === 'questions' && <MockInterviewQuestionsSubTab />}
        {activeSubTab === 'generation' && <MockInterviewGenerationSubTab />}
        {activeSubTab === 'statistics' && <MockInterviewStatisticsSubTab />}
        {activeSubTab === 'user-interviews' && <UserMockInterviewsSubTab />}
        {activeSubTab === 'user-questions' && <UserMockInterviewQuestionsSubTab />}
        {activeSubTab === 'user-completions' && <UserMockInterviewCompletionsSubTab />}
      </div>
    </div>
  );
}

export default MockInterviewsTab;

